import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'pkp-g-settings-page',
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class SettingsPage {}
